import React, { useContext, Fragment, useEffect } from "react";
import { EquipeContext } from "../EquipeContext";
import Pesquisar from "../../../../../Components/Cadastro/Pesquisar/Pesquisar";
import TabelaResultados from "../../../../../Components/Cadastro/TabelaResultados/TabelaResultados";

const PesquisarEquipe = () => {
  const { values, setValues, resetScreen } = useContext(EquipeContext);

  useEffect(() => {
    resetScreen();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  function onChangeInput(event) {
    const { name, value } = event.target;
    setValues({
      ...values,
      searchData: {
        ...values.searchData,
        [name]: value,
      },
    });
  }

  return (
    <Fragment>
      <Pesquisar context={EquipeContext}>
        <div className="col-12 col-md-3">
          <label>Nome da Equipe</label>
          <input
            className="form-control"
            type="text"
            name="equipeNome"
            value={values.searchData.equipeNome}
            onChange={onChangeInput}
          />
        </div>
        <div className="col-12 col-md-3">
          <label>Produto</label>
          <select
            className="form-control"
            name="produtoId"
            value={values.searchData.produtoId}
            onChange={onChangeInput}
          >
            <option className="disabled" value="0"></option>
            {values.produtos.map((produto) => (
              <option key={produto.produtoId} value={produto.produtoId}>
                {produto.produtoNome}
              </option>
            ))}
          </select>
        </div>
      </Pesquisar>
      <TabelaResultados context={EquipeContext} />
    </Fragment>
  );
};

export default PesquisarEquipe;
